// Auto-scroll horizontal do board durante o drag de um card: o drag HTML5
// nativo não rola containers com overflow, então arrastar da 1ª à última
// coluna obrigava a soltar no meio do caminho (sujando o histórico com
// etapas pelas quais o lead nunca passou).

export const EDGE_ZONE = 96; // px da borda que ativa o auto-scroll
export const MAX_SPEED = 24; // px por frame na borda extrema

/**
 * Calcula direção e velocidade do auto-scroll a partir da posição do cursor.
 * @param {number} clientX posição X do cursor
 * @param {{left: number, right: number}} rect bounding rect do board
 * @returns {{direction: -1|0|1, speed: number}}
 */
export function getEdgeScroll(clientX, rect) {
  const fromLeft = clientX - rect.left;
  const fromRight = rect.right - clientX;

  // Cursor fora do board (dragover de um filho que vaza): não rola.
  if (fromLeft < 0 || fromRight < 0) return { direction: 0, speed: 0 };

  if (fromLeft < EDGE_ZONE) {
    return {
      direction: -1,
      speed: Math.ceil(((EDGE_ZONE - fromLeft) / EDGE_ZONE) * MAX_SPEED),
    };
  }

  if (fromRight < EDGE_ZONE) {
    return {
      direction: 1,
      speed: Math.ceil(((EDGE_ZONE - fromRight) / EDGE_ZONE) * MAX_SPEED),
    };
  }

  return { direction: 0, speed: 0 };
}
